import { useSuspenseQuery } from "@tanstack/react-query";
import { useTRPC } from "@/trpc/client";

export const useGetStudySet = (id: string) => {
  const trpc = useTRPC();
  return useSuspenseQuery(
    trpc.studysets.getById.queryOptions({
      id,
    }),
  );
};
